<template>
  <div class="icon-state-box">
    <span
      class="icon-warn"
      :class="data.state | stateClass(true)"
      v-for="icon in icons"
      :key="icon"
    >
      <em class="icon iconfont" :class="icon"></em>
    </span>
  </div>
</template>

<script>
import mixins from '../../mixins/stateMixin';

export default {
  mixins: [mixins],
  props: {
    data: [Object, undefined]
  },
  computed: {
    icons() {
      return this.stateIcon(this.data.state, this.data.types);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-state-box {
  display: flex;
  align-items: center;
  .icon-text {
    @include state-textstyle;
    margin-right: 5px;
  }
  .icon-warn {
    @include state-bgstyle;
    display: inline-block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 2px;
    em {
      color: #12283a;
    }
  }
}
</style>
